import IntercomService from '../../../intercom/IntercomService';

export abstract class EventAdapter<EventData = any> {
  protected eventData: EventData;
  protected abstract intercomEventKey: string;
  protected abstract amplitudeEventFunction: (data: EventData) => void;

  public sendAnalytics() {
    try {
      this.sendIntercomEvent();
    } catch (err) {
      console.error('Failed to send intercom event', err);
    }

    try {
      this.sendAmplitudeEvent();
    } catch (err) {
      console.error('Failed to send amplitude event', err);
    }
  }

  protected sendIntercomEvent() {
    if (this.intercomEventKey) {
      IntercomService.event(this.intercomEventKey);
      __DEV__ && console.log('Send Intercom Event', this.intercomEventKey);
    }
  }

  protected sendAmplitudeEvent() {
    if (this.amplitudeEventFunction) {
      this.amplitudeEventFunction(this.eventData);
    }
  }
}
